import React, { useContext, useEffect, useState } from "react";
import { axiosUrl } from "../../api/axios";
import { UserContext } from "../../App";
import DashboardLayout from "../../layouts/DashboardLayout";

const Transactions = () => {
  const [transactions, setTransactions] = useState([]);
  const { userData } = useContext(UserContext);

  useEffect(() => {
    axiosUrl
      .get("/transactions")
      .then((response) => setTransactions(response.data));
    // .then((response) => console.log(response.data));
  }, []);

  return (
    <DashboardLayout>
      <div className="transactions">
        <h3 className="sharp-text title-text">Transaction History</h3>

        <div className="top-nav">
          <a
            href="http://t.me/+bgUq1S1ZBZY1YTQ0"
            target="_blank"
            rel="noreferrer"
          >
            <button className="btn rounded">
              <i className="fas fa-paper-plane"></i>
              <p className="sharp-text">Contact Support</p>
            </button>
          </a>
        </div>

        <div className="transaction-list">
          <ul>
            <li className="list-title">
              <p className="sharp-text">Type</p>
              <p className="sharp-text">Amount</p>
              <p className="sharp-text">Status</p>
              <p className="sharp-text">Date</p>
            </li>
            <hr />
            <li className="recent-transaction">
              <p className="sharp-text">Sign Up Bonus</p>
              <p className="sharp-text">$10</p>
              <p
                className="sharp-text"
                style={{
                  color: "green",
                }}
              >
                Completed
              </p>
              <p className="sharp-text">{userData.user.date}</p>
            </li>
            {transactions
              .filter((transaction) => transaction.userId === userData.user.id)
              .map((transaction) => {
                return (
                  <li key={transaction._id} className="recent-transaction">
                    <p className="sharp-text">{transaction.type}</p>
                    <p className="sharp-text">{transaction.amount}</p>
                    <p
                      className="sharp-text"
                      style={{
                        color: transaction.status === true ? "green" : "red",
                      }}
                    >
                      {transaction.status === true ? "Completed" : "Pending"}
                    </p>
                    <p className="sharp-text">
                      {transaction.date.slice(0, 10)}
                    </p>
                  </li>
                );
              })}
          </ul>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default Transactions;
